import { offWindowResize, onWindowResize } from "@tarojs/taro";
import { useEffect } from "react";
function useWindowResize(callback) {
    useEffect(() => {
        onWindowResize?.(callback);
        return () => offWindowResize?.(callback);
    }, [callback]);
}
export default useWindowResize;
